import { useShouldRenderVolumePricing } from '../../../product'
import { useProductPageContext } from '../productPageContext'

export const useShouldRenderVolumePricingLabel = (): boolean => {
  const { currentOffer } = useProductPageContext()

  return useShouldRenderVolumePricing(
    currentOffer?.volumeBasedPrices ?? undefined,
  )
}
